import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SimpleLayoutComponent } from '../simple-layout/simple-layout.component';
import { RouterModule } from '@angular/router';
import { ReactiveFormsModule } from '@angular/forms';
import { SidebarComponent } from './components/sidebar/sidebar.component';
import { NavbarComponent } from './components/navbar/navbar.component';
import { NbContactComponent } from './components/navbar/nb-contact/nb-contact.component';
import { DialogModule } from 'primeng/dialog';
import { ButtonModule } from 'primeng/button';
import { Sidebar2Component } from './components/sidebar2/sidebar2.component';
import { TranslatePipe } from 'src/app/pipe/translate.pipe';
import { MenuModule } from 'primeng/menu';


@NgModule({
  declarations: [
    SimpleLayoutComponent,
    SidebarComponent,
    NavbarComponent,
    NbContactComponent,
    Sidebar2Component,
    TranslatePipe

  ],
  imports: [
    CommonModule,
    RouterModule,
    ReactiveFormsModule,
    DialogModule,
    ButtonModule,
    MenuModule

  ],
  exports: [
    SimpleLayoutComponent,
    SidebarComponent,
    NavbarComponent,
    Sidebar2Component,
    TranslatePipe
  ]
})
export class SimpleLayoutModule { }
